var ttVideo = {
  init: function () {
    var s = this;

    $('.video-wrap').each(function () {
      var th = $(this);
      var cover_el = th.find('.cover');

      if (th.is('.init') || cover_el.length == 0) return;

      cover_el.on('click', function () {
        s.play(th);
      });

      // $video.on('ended', function () {
      //   th.removeClass('showvideo');
      // });

      // if ($('html').is('.skrollr')) {
      //   th.on('dataBottomTop dataTopBottom', function () {
      //     s.pause(th);
      //   });
      // }

      th.addClass('init');
    });

    document.removeEventListener("visibilitychange", s.visiChange);
    document.addEventListener("visibilitychange", s.visiChange);

    // $('.pswp_video_thumb').each(function () {
    //   var th = $(this);
    //   var video_w = th.data('pswp-width');
    //   var video_h = th.data('pswp-height');
    //   var img_h = th.innerHeight();
    //   th.find('img').css('width', img_h * video_w / video_h);
    // });
  },

  play: function (emt) {
    $(emt).addClass('showvideo');
    $(emt).find('video').trigger("play");
  },
  pause: function (emt) {
    $(emt).find('video').trigger("pause");
  },

  visiChange: function () {
    if (document.hidden && $('video').length) {
      $('video')[0].pause();
    }
  },

  kill: function () {
    var s = this;
    if ($('video').length) $('video')[0].pause();
    document.removeEventListener("visibilitychange", s.visiChange);
    // tt_root_scroll_wrap.off('scroll.video');
    // if ($('html').is('.skrollr'))
    //   $('.video-wrap').off('dataBottomTop dataTopBottom');
  }
}